import { configureVf } from '@signal24/vue-foundation';
import { nextTick, ref, watch } from 'vue';
import { GlobalState } from './global';
import { serviceWorkerManager } from './shared/services/sw.manager';

export function useAppServiceWorker() {
    watch(GlobalState.tenant, () => {
        serviceWorkerManager.postPageContext();
    });

    const isModalDisplayed = ref(false);
    configureVf({
        onOverlaysChanged() {
            nextTick(() => {
                isModalDisplayed.value = document.querySelector('.vf-modal') !== null;
            });
        }
    });
    watch(isModalDisplayed, isModalDisplayed => {
        serviceWorkerManager.postMessage('updatePageContext', { modalOpen: isModalDisplayed });
    });
}
